
import React, { useEffect, useState } from 'react';
import { Button, Card, List } from 'antd';
import strings from '../../utils/strings';
import moment from 'moment-jalaali';
import { useNavigate } from 'react-router-dom';
// import { toggleInsuranceDetailsModal } from '../../actions/ReportsActions';
import InsuranceDetails from "../shared/insuranceDetails/InsuranceDetails";
import { usePersistedStore } from '../../store/persisted-store';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';

export default function Notifications() {

    const { auth, business } = usePersistedStore();
    const navigate = useNavigate();
    const general = useGeneralStore();
    const notifications = general.notifications.data;
    const loading = general.notifications.loading;
    const currentBusiness = business.currentBusiness;
    const userInfoResources = auth.userInfo.Resources;
    const { token } = currentBusiness;
    const [requestId, setRequestId] = useState();

    useEffect(() => {
        if (!token)
            navigate('/dashboard');
    }, [])

    return (
        <div>
            <Card>
                <List
                    loading={loading}
                    itemLayout="horizontal"
                    dataSource={notifications}
                    pagination={{ pageSize: 10 }}
                    renderItem={item => (
                        <List.Item
                            actions={[
                                item.EntityType === "InsuranceRequest" &&
                                userInfoResources &&
                                (userInfoResources.includes("BusinessSaleReport") ||
                                    userInfoResources.includes("BusinessSupportReport")) && <Button type="link"
                                        onClick={() => {
                                            setRequestId(item.EntityId);
                                            general.ToggleInsuranceDetailsModal();
                                        }}
                                        size="small" >جزئیات</Button>
                            ]}
                        >
                            <List.Item.Meta
                                title={item.Description}
                                description={strings.getFarsiNum(moment(item.NotifDate).format('jYYYY/jMM/jDD - HH:mm'))}
                            />
                        </List.Item>
                    )}
                />
            </Card>
            <InsuranceDetails requestId={requestId} />
        </div >
    )
}


